import authenticated from './authenticated';
import restricted from './restricted';

export { authenticated, restricted };



// WEBPACK FOOTER //
// ./src/components/general/restricted/index.jsx